export const DOCUMENTATION = {
  TERMS_AND_CONDITIONS:
    '/companyPdfs/Faes_General_terms_and_conditions_202402.pdf',
  SUPPORT_PACK: '/companyPdfs/Support_Pack_202402.pdf',
  API_DOCS: `${process.env.VUE_APP_API_GLOBAL_URL}docs`,
}
